import { useQuery } from '@tanstack/react-query';
import { listPastSupportChats } from '../services/chatApi';
import { SUPPORT_PAST_CHATS_STALE_MS } from '../constants/support';
import { supportKeys } from './queryKeys';
const NO_CHATS = [];
/**
 * The signed-in user's finished live chats with InspectPoint Support, for the drawer's
 * "Support chats" shortcut. Best-effort: a failed read is no list, never an error in the widget.
 */
export function usePastSupportChats({ enabled, hasAiToken }) {
    var _a;
    const query = useQuery({
        queryKey: supportKeys.pastChats(),
        queryFn: listPastSupportChats,
        enabled: enabled && hasAiToken,
        staleTime: SUPPORT_PAST_CHATS_STALE_MS,
        retry: false,
        refetchOnWindowFocus: false
    });
    return (_a = query.data) !== null && _a !== void 0 ? _a : NO_CHATS;
}
